module.exports = __webpack_public_path__ + "img/nodata.30f7f318.png";